<script>
	import { getContext, onDestroy } from 'svelte'
	import { slide } from 'svelte/transition'
	import { styles } from '../../library/scripts/styles'
	import { storeElementID, storeData, storeSelectedIcon, storeColumnTemplate } from '../../library/scripts/Store.svelte'
	import { get_initial_values, get_element_tags, create_column_template } from '../builderUtils'
	import ColorSelector from '../ColorSelector.svelte'
	import SizeSelector from '../SizeSelector.svelte'

	export let width

	const globals = getContext('globals')
	const fsXL = globals.fsXL
	const fsX = globals.fsX
	const fsL = globals.fsL
	const fsN = globals.fsN
	const fsS = globals.fsS
	const fsXS = globals.fsXS
	const icon = globals.icon
	const iconColor = globals.colorDark
	const iconHover = globals.colorError
	let mainTool = globals.mainTool
	let mainToolHover = globals.mainToolHover
	let subTool = globals.subTool
	let subToolHover = globals.subToolHover

	let elementID
	let config
	let blocks
	let blockID
	let columnID
	let elementTag

	//show hide tool
	let generalTool
	let showTool1
	let showTool2
	let showTool3

	//the selectedIcon from store
	let selectedStoreIcon

	//the values to send to sizeSelectors
	let selectedBorderWidth

	//css selections
	let selectedBorderColor = 'hsla(0,0%,0%,1)'
	let selectedColor
	let selectedBackground
	let selectedBgOpac
	let selectedMarginTop
	let selectedMarginBottom
	let selectedPadding
	let selectedBLwidth
	let selectedBLcolor
	let selectedBTwidth
	let selectedBTcolor
	let selectedBRwidth
	let selectedBRcolor
	let selectedBBwidth
	let selectedBBcolor
	let selectedBTradius
	let selectedBBradius
	let selectedSColor
	let selectedSOpac
	let selectedSX
	let selectedSY
	let selectedSBlur

	//icon selected
	let selectedIcon

	//set icons
	let icon1 = false
	let icon2 = false
	let icon3 = false
	let icon4 = false
	let icon5 = false

	let icon1Color = iconColor
	let icon2Color = iconColor
	let icon3Color = iconColor
	let icon4Color = iconColor
	let icon5Color = iconColor

	//stative ID for getElementById in SelectValues
	const idColor1 = '101'
	const idColor2 = '102'
	const idColor3 = '103'
	const idMarginTop = '3'
	const idMarginBottom = '4'
	const idPadding = '5'
	const idBorderWidth = '6'
	const idBTradius = '7'
	const idBBradius = '8'
	const idShadowX = '14'
	const idShadowY = '15'
	const idShadowBlur = '16'

	//show border tools
	let iconSelected = false

	//template
	let template

	const stoTemplate = storeColumnTemplate.subscribe((value) => {
		template = value
	})
	const stoData = storeData.subscribe((value) => {
		if (value) {
			config = value
			blocks = value.blocks
		}
	})

	const stoElementID = storeElementID.subscribe((value) => {
		elementID = value
	})

	const stoSelectedIcon = storeSelectedIcon.subscribe((value) => {
		selectedStoreIcon = value
	})

	//set the initial css values from config.json
	$: if (elementID.indexOf('column') > -1) {
		const tags = get_element_tags(elementID)
		blockID = tags[0]
		columnID = tags[1]
		elementTag = tags[2]
		const values = get_initial_values(elementID, blocks, tags)
		selectedBackground = values[0]
		selectedBgOpac = values[1]
		selectedMarginTop = values[2]
		selectedMarginBottom = values[3]
		selectedPadding = values[4]
		selectedBLwidth = values[5]
		selectedBLcolor = values[6]
		selectedBTwidth = values[7]
		selectedBTcolor = values[8]
		selectedBRwidth = values[9]
		selectedBRcolor = values[10]
		selectedBBwidth = values[11]
		selectedBBcolor = values[12]
		selectedBTradius = values[13]
		selectedBBradius = values[14]
		selectedSX = values[15]
		selectedSY = values[16]
		selectedSBlur = values[17]
		selectedSColor = values[18]
		selectedSOpac = values[19]

		if (selectedBLwidth > 0) {
			icon1 = true
			set_icon_color('left')
		}
		if (selectedBTwidth > 0) {
			icon2 = true
			set_icon_color('top')
		}

		if (selectedBRwidth > 0) {
			icon3 = true
			set_icon_color('right')
		}

		if (selectedBBwidth > 0) {
			icon4 = true
			set_icon_color('bottom')
		}

		if (selectedBLwidth > 0 && selectedBTwidth > 0 && selectedBRwidth > 0 && selectedBBwidth > 0) {
			icon1 = true
			icon2 = true
			icon3 = true
			icon4 = true
			icon5 = true
			set_icon_color('all')
		}
	}

	$: if (!icon1 && !icon2 && !icon3 && !icon4 && !icon5) iconSelected = false

	$: if (selectedStoreIcon === 'icon1') selectedBorderWidth = selectedBLwidth
	$: if (selectedStoreIcon === 'icon2') selectedBorderWidth = selectedBTwidth
	$: if (selectedStoreIcon === 'icon3') selectedBorderWidth = selectedBRwidth
	$: if (selectedStoreIcon === 'icon4') selectedBorderWidth = selectedBBwidth
	$: if (selectedStoreIcon === 'icon5') selectedBorderWidth = selectedBLwidth

	const set_icon_color = (c) => {
		if (c === 'left') icon1Color = iconHover
		if (c === 'top') icon2Color = iconHover
		if (c === 'right') icon3Color = iconHover
		if (c === 'bottom') icon4Color = iconHover
		if (c === 'all') {
			icon1Color = iconHover
			icon2Color = iconHover
			icon3Color = iconHover
			icon4Color = iconHover
			icon5Color = iconHover
		}
		if (c === 'none') {
			icon1Color = iconColor
			icon2Color = iconColor
			icon3Color = iconColor
			icon4Color = iconColor
			icon5Color = iconColor
		}
	}
	const set_css_tag = (cssTag, cmd) => {
		blocks.forEach((block) => {
			if (block.blockName === blockID) {
				if (cmd === 'bg') {
					block.content[columnID - 1].backgroundColor = cssTag
				}

				if (cmd === 'sX') {
					block.content[columnID - 1].columnBoxShadowX = cssTag
				}

				if (cmd === 'sY') {
					block.content[columnID - 1].columnBoxShadowY = cssTag
				}

				if (cmd === 'sB') {
					block.content[columnID - 1].columnBoxShadowBlur = cssTag
				}

				if (cmd === 'sC') {
					block.content[columnID - 1].columnBoxShadowColor = cssTag
				}

				if (cmd === 'bL') {
					if (icon1 && selectedIcon === 'icon1') {
						block.content[columnID - 1].borderLeftColor = cssTag
						block.content[columnID - 1].borderLeftWidth = '1'
						icon1Color = iconHover
						if (icon1 && icon2 && icon3 && icon4) icon5Color = iconHover
					} else {
						block.content[columnID - 1].borderLeftWidth = '0'
						icon1Color = iconColor
						icon5Color = iconColor
					}
				}

				if (cmd === 'bT') {
					if (icon2 && selectedIcon === 'icon2') {
						block.content[columnID - 1].borderTopColor = cssTag
						block.content[columnID - 1].borderTopWidth = '1'
						icon2Color = iconHover
						if (icon1 && icon2 && icon3 && icon4) icon5Color = iconHover
					} else {
						block.content[columnID - 1].borderTopWidth = '0'
						icon2Color = iconColor
						icon5Color = iconColor
					}
				}

				if (cmd === 'bR') {
					if (icon3 && selectedIcon === 'icon3') {
						block.content[columnID - 1].borderRightColor = cssTag
						block.content[columnID - 1].borderRightWidth = '1'
						icon3Color = iconHover
						if (icon1 && icon2 && icon3 && icon4) icon5Color = iconHover
					} else {
						block.content[columnID - 1].borderRightWidth = '0'
						icon3Color = iconColor
						icon5Color = iconColor
					}
				}

				if (cmd === 'bB') {
					if (icon4 && selectedIcon === 'icon4') {
						block.content[columnID - 1].borderBottomColor = cssTag
						block.content[columnID - 1].borderBottomWidth = '1'
						icon4Color = iconHover
						if (icon1 && icon2 && icon3 && icon4) icon5Color = iconHover
					} else {
						block.content[columnID - 1].borderBottomWidth = '0'
						icon4Color = iconColor
						icon5Color = iconColor
					}
				}

				if (cmd === 'bA') {
					if (icon5 && selectedIcon === 'icon5') {
						block.content[columnID - 1].borderLeftColor = cssTag
						block.content[columnID - 1].borderLeftWidth = '1'
						block.content[columnID - 1].borderTopColor = cssTag
						block.content[columnID - 1].borderTopWidth = '1'
						block.content[columnID - 1].borderRightColor = cssTag
						block.content[columnID - 1].borderRightWidth = '1'
						block.content[columnID - 1].borderBottomColor = cssTag
						block.content[columnID - 1].borderBottomWidth = '1'
						icon5Color = iconHover
						icon1Color = iconHover
						icon2Color = iconHover
						icon3Color = iconHover
						icon4Color = iconHover
					} else {
						block.content[columnID - 1].borderLeftWidth = '0'
						block.content[columnID - 1].borderTopWidth = '0'
						block.content[columnID - 1].borderRightWidth = '0'
						block.content[columnID - 1].borderBottomWidth = '0'
						icon5Color = iconColor
						icon1Color = iconColor
						icon2Color = iconColor
						icon3Color = iconColor
						icon4Color = iconColor
						icon1 = false
						icon2 = false
						icon3 = false
						icon4 = false
						icon5 = false
					}
				}

				if (cmd === 'bWidth') {
					if (icon1 && selectedIcon === 'icon1') block.content[columnID - 1].borderLeftWidth = cssTag
					if (icon2 && selectedIcon === 'icon2') block.content[columnID - 1].borderTopWidth = cssTag
					if (icon3 && selectedIcon === 'icon3') block.content[columnID - 1].borderRightWidth = cssTag
					if (icon4 && selectedIcon === 'icon4') block.content[columnID - 1].borderBottomWidth = cssTag
					if (icon5 && selectedIcon === 'icon5') {
						block.content[columnID - 1].borderLeftWidth = cssTag
						block.content[columnID - 1].borderTopWidth = cssTag
						block.content[columnID - 1].borderRightWidth = cssTag
						block.content[columnID - 1].borderBottomWidth = cssTag
					}
				}

				if (cmd === 'bColor' || cmd === 'bOpacity') {
					if (icon1 && selectedIcon === 'icon1') block.content[columnID - 1].borderLeftColor = cssTag
					if (icon2 && selectedIcon === 'icon2') block.content[columnID - 1].borderTopColor = cssTag
					if (icon3 && selectedIcon === 'icon3') block.content[columnID - 1].borderRightColor = cssTag
					if (icon4 && selectedIcon === 'icon4') block.content[columnID - 1].borderBottomColor = cssTag
					if (icon5 && selectedIcon === 'icon5') {
						block.content[columnID - 1].borderLeftColor = cssTag
						block.content[columnID - 1].borderTopColor = cssTag
						block.content[columnID - 1].borderRightColor = cssTag
						block.content[columnID - 1].borderBottomColor = cssTag
					}
				}

				if (cmd === 'btRadius') {
					block.content[columnID - 1].borderTopRadius = cssTag
				}

				if (cmd === 'bbRadius') {
					block.content[columnID - 1].borderBottomRadius = cssTag
				}
			}
		})

		config.blocks = blocks
		storeData.set(config)
	}

	const set_bg_color = (e) => {
		const hsl = e.detail.color
		set_css_tag(hsl, 'bg')
	}

	const set_border_color = (e) => {
		set_css_tag(e.detail.color, 'bColor')
	}

	const set_border_opacity = (e) => {
		set_css_tag(e.detail.color, 'bColor')
	}

	const set_border_width = (e) => {
		set_css_tag(e.detail.value, 'bWidth')
	}

	const set_border_top_radius = (e) => {
		set_css_tag(e.detail.value, 'btRadius')
	}

	const set_border_bottom_radius = (e) => {
		set_css_tag(e.detail.value, 'bbRadius')
	}

	const set_icon_1 = () => {
		iconSelected = true
		selectedIcon = 'icon1'
		storeSelectedIcon.set('icon1')
		icon1 = icon1 === false ? true : false
		if (icon1) icon1Color = iconHover
		else icon1Color = iconColor
		set_css_tag('hsla(0,0%,0%,1)', 'bL')
	}
	const set_icon_2 = () => {
		iconSelected = true
		selectedIcon = 'icon2'
		storeSelectedIcon.set('icon2')
		icon2 = icon2 === false ? true : false
		if (icon2) icon2Color = iconHover
		else icon2Color = iconColor
		set_css_tag('hsla(0,0%,0%,1)', 'bT')
	}

	const set_icon_3 = () => {
		iconSelected = true
		selectedIcon = 'icon3'
		storeSelectedIcon.set('icon3')
		icon3 = icon3 === false ? true : false
		if (icon3) icon3Color = iconHover
		else icon3Color = iconColor
		set_css_tag('hsla(0,0%,0%,1)', 'bR')
	}

	const set_icon_4 = () => {
		iconSelected = true
		selectedIcon = 'icon4'
		storeSelectedIcon.set('icon4')
		icon4 = icon4 === false ? true : false
		if (icon4) icon4Color = iconHover
		else icon4Color = iconColor
		set_css_tag('hsla(0,0%,0%,1)', 'bB')
	}

	const set_icon_5 = () => {
		iconSelected = true
		selectedIcon = 'icon5'
		storeSelectedIcon.set('icon5')
		icon5 = icon5 === false ? true : false
		if (icon5) icon5Color = iconHover
		else icon5Color = iconColor
		set_css_tag('hsla(0,0%,0%,1)', 'bA')
	}

	const set_margin_top = (e) => {
		const value = e.detail.value
		blocks.forEach((block) => {
			if (block.blockName === blockID) {
				block.content[columnID - 1].marginTop = value
				config.blocks = blocks
				storeData.set(config)
			}
		})
	}

	const set_margin_bottom = (e) => {
		const value = e.detail.value
		blocks.forEach((block) => {
			if (block.blockName === blockID) {
				block.content[columnID - 1].marginBottom = value
				config.blocks = blocks
				storeData.set(config)
			}
		})
	}

	const set_padding = (e) => {
		const value = e.detail.value
		blocks.forEach((block) => {
			if (block.blockName === blockID) {
				block.content[columnID - 1].padding = value
				config.blocks = blocks
				storeData.set(config)
			}
		})
	}

	const create_template = () => {
		storeColumnTemplate.set([blockID, columnID, elementTag])
	}

	const use_template = async () => {
		const b = blocks
		const temp = await create_column_template(template, blockID, columnID, b)

		config.blocks = temp
		storeData.set(config)
	}

	const set_offset_x = (e) => {
		set_css_tag(e.detail.value, 'sX')
	}

	const set_offset_y = (e) => {
		set_css_tag(e.detail.value, 'sY')
	}

	const set_blur = (e) => {
		set_css_tag(e.detail.value, 'sB')
	}

	const set_shadow_color = (e) => {
		set_css_tag(e.detail.color, 'sC')
	}

	const set_shadow_opacity = (e) => {
		set_css_tag(e.detail.color, 'sC')
	}

	let toTool
	const open_tool = (t) => {
		if (t === 'generalTool') {
			generalTool = generalTool === true ? false : true
			showTool2 = false
			showTool3 = false
			return
		}
		if (t === 1) {
			showTool1 = showTool1 === true ? false : true
			return
		}

		if (t === 2) {
			showTool2 = showTool2 === true ? false : true
			generalTool = false
			showTool3 = false
			if (showTool2) {
				if (!icon1) icon1Color = iconColor
				if (!icon2) icon2Color = iconColor
				if (!icon3) icon3Color = iconColor
				if (!icon4) icon4Color = iconColor
				if (!icon1 || !icon2 || !icon3 || !icon4) icon5Color = iconColor

				toTool = setTimeout(() => {
					icon1Color = icon1Color
					icon2Color = icon2Color
					icon3Color = icon3Color
					icon4Color = icon4Color
					icon5Color = icon5Color
				}, 10)
			}
			return
		}

		if (t === 3) {
			showTool3 = showTool3 === true ? false : true
			generalTool = false
			showTool2 = false
			return
		}
	}

	onDestroy(() => {
		stoElementID
		stoData
		stoSelectedIcon
		stoTemplate
		clearTimeout(toTool)
	})
</script>

{#if config}
	<main use:styles={{ width }}>
		<div class="template" use:styles={{ fsXS, iconHover }} on:click={create_template} on:keydown={create_template}>
			Create Template
		</div>
		{#if template}
			<div class="sub_template" use:styles={{ fsXS, iconHover }} on:click={use_template} on:keydown={use_template}>
				Use Template
			</div>
		{/if}
		<div
			class="part_title mainTool"
			on:click={() => open_tool(1)}
			on:keydown={() => open_tool(1)}
			use:styles={{ mainTool, mainToolHover, fsXS }}
		>
			COLUMN CONTAINER
		</div>
		{#if showTool1}
			<div transition:slide={{ duration: 500 }}>
				<div
					class="part_title subTool"
					on:click={() => open_tool('generalTool')}
					on:keydown={() => open_tool('generalTool')}
					use:styles={{ subTool, subToolHover, fsXS }}
				>
					general
				</div>
				{#if generalTool}
					<div transition:slide={{ duration: 500 }}>
						<div class="sub_title" use:styles={{ fsXS }}>Background</div>
						<ColorSelector
							on:setcolor={set_bg_color}
							on:setopacity={set_bg_color}
							on:settransparent={set_bg_color}
							transparent="1"
							ID={idColor1}
							selectedColor={selectedBackground}
							initialValue={selectedBgOpac}
						/>
						<div class="sub_title" use:styles={{ fsXS }}>Margin Top</div>
						<SizeSelector ID={idMarginTop} range="5" initialValue={selectedMarginTop} on:sizechange={set_margin_top} />

						<div class="sub_title" use:styles={{ fsXS }}>Margin Bottom</div>
						<SizeSelector
							ID={idMarginBottom}
							range="5"
							initialValue={selectedMarginBottom}
							on:sizechange={set_margin_bottom}
						/>

						<div class="sub_title" use:styles={{ fsXS }}>Padding</div>
						<SizeSelector ID={idPadding} range="5" initialValue={selectedPadding} on:sizechange={set_padding} />
					</div>
				{/if}
				<div
					class="part_title subTool"
					on:click={() => open_tool(2)}
					on:keydown={() => open_tool(2)}
					use:styles={{ subTool, subToolHover, fsXS }}
				>
					border
				</div>
				{#if showTool2}
					<div transition:slide={{ duration: 500 }}>
						<div class="icon_container">
							<div
								id="icon1"
								class="icon icon1"
								use:styles={{ icon, icon1Color, iconHover }}
								on:click={set_icon_1}
								on:keydown={set_icon_1}
							/>
							<div
								id="icon2"
								class="icon icon2"
								use:styles={{ icon, icon2Color, iconHover }}
								on:click={set_icon_2}
								on:keydown={set_icon_2}
							/>
							<div
								id="icon3"
								class="icon icon3"
								use:styles={{ icon, icon3Color, iconHover }}
								on:click={set_icon_3}
								on:keydown={set_icon_3}
							/>
							<div
								id="icon4"
								class="icon icon4"
								use:styles={{ icon, icon4Color, iconHover }}
								on:click={set_icon_4}
								on:keydown={set_icon_4}
							/>
							<div
								id="icon5"
								class="icon icon5"
								use:styles={{ icon, icon5Color, iconHover }}
								on:click={set_icon_5}
								on:keydown={set_icon_5}
							/>
						</div>
						{#if iconSelected}
							<div in:slide={{ duration: 100 }}>
								<div class="sub_title" use:styles={{ fsXS }}>Border Color</div>
								<ColorSelector
									on:setcolor={set_border_color}
									on:setopacity={set_border_opacity}
									ID={idColor2}
									selectedColor={selectedBorderColor}
									initialValue={selectedBgOpac}
								/>

								<div class="sub_title" use:styles={{ fsXS }}>Border Width</div>
								<SizeSelector
									ID={idBorderWidth}
									range="50"
									unit="px"
									initialValue={selectedBorderWidth}
									on:sizechange={set_border_width}
								/>

								<div class="sub_title" use:styles={{ fsXS }}>Border Top Radius</div>
								<SizeSelector
									ID={idBTradius}
									range="20"
									unit="px"
									initialValue={selectedBTradius}
									on:sizechange={set_border_top_radius}
								/>

								<div class="sub_title" use:styles={{ fsXS }}>Border Bottom Radius</div>
								<SizeSelector
									ID={idBBradius}
									range="20"
									unit="px"
									initialValue={selectedBBradius}
									on:sizechange={set_border_bottom_radius}
								/>
							</div>
						{/if}
					</div>
				{/if}
				<div
					class="part_title subTool"
					on:click={() => open_tool(3)}
					on:keydown={() => open_tool(3)}
					use:styles={{ subTool, subToolHover, fsXS }}
				>
					shadow
				</div>
				{#if showTool3}
					<div transition:slide={{ duration: 500 }}>
						<ColorSelector
							on:setcolor={set_shadow_color}
							on:setopacity={set_shadow_opacity}
							ID={idColor3}
							selectedColor={selectedSColor}
							initialValue={selectedSOpac}
						/>

						<div class="sub_title" use:styles={{ fsXS }}>Offset X</div>
						<SizeSelector ID={idShadowX} range="20" unit="px" initialValue={selectedSX} on:sizechange={set_offset_x} />

						<div class="sub_title" use:styles={{ fsXS }}>Offset Y</div>
						<SizeSelector ID={idShadowY} range="20" unit="px" initialValue={selectedSY} on:sizechange={set_offset_y} />

						<div class="sub_title" use:styles={{ fsXS }}>Blur</div>
						<SizeSelector
							ID={idShadowBlur}
							range="20"
							unit="px"
							initialValue={selectedSBlur}
							on:sizechange={set_blur}
						/>
					</div>
				{/if}
			</div>
		{/if}
	</main>
{/if}

<style>
	main {
		width: var(--with);
		user-select: none;
	}
	.sub_title {
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: 100%;
		background: hsl(0, 0%, 70%);
		color: black;
		padding: 10px;
		border-bottom: 1px solid black;
	}

	.part_title {
		display: flex;
		width: 100%;
		justify-content: center;
		border-bottom: none;
		font-size: var(--fsXS);
		font-weight: bold;
		background-color: chocolate;
		padding: 10px;
		margin-top: 10px;
		cursor: pointer;
	}

	.sub_title {
		font-size: var(--fsXS);
		border-bottom: none;
		padding: 10px 0px 3px 10px;
	}

	.template,
	.sub_template {
		display: flex;
		justify-content: center;
		width: 100%;
		font-size: var(--fsXS);
		padding: 10px 0px 10px 10px;
		cursor: pointer;
		background-color: darkslategrey;
		text-transform: uppercase;
		color: white;
		margin-top: 5px;
	}

	.template:hover,
	.sub_template:hover {
		color: var(--iconHover);
	}

	.icon_container {
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(40px, 1fr));
		padding: 2%;
	}

	.icon {
		display: inline-block;
		width: var(--icon);
		height: var(--icon);
		mask-size: cover;
		-webkit-mask-size: cover;
		cursor: pointer;
	}

	.icon:hover {
		background-color: var(--iconHover);
	}

	.icon1 {
		background-color: var(--icon1Color);
		mask: url('/images/tools/borderL.svg') no-repeat;
		-webkit-mask: url('/images/tools/borderL.svg') no-repeat;
	}

	.icon2 {
		background-color: var(--icon2Color);
		mask: url('/images/tools/borderT.svg') no-repeat;
		-webkit-mask: url('/images/tools/borderT.svg') no-repeat;
	}

	.icon3 {
		background-color: var(--icon3Color);
		mask: url('/images/tools/borderR.svg') no-repeat;
		-webkit-mask: url('/images/tools/borderR.svg') no-repeat;
	}

	.icon4 {
		background-color: var(--icon4Color);
		mask: url('/images/tools/borderB.svg') no-repeat;
		-webkit-mask: url('/images/tools/borderB.svg') no-repeat;
	}

	.icon5 {
		background-color: var(--icon5Color);
		mask: url('/images/tools/borderA.svg') no-repeat;
		-webkit-mask: url('/images/tools/borderA.svg') no-repeat;
	}

	.subTool {
		background-color: var(--subTool);
	}

	.subTool:hover {
		background-color: var(--subToolHover);
	}

	.mainTool {
		background-color: var(--mainTool);
	}

	.mainTool:hover {
		background-color: var(--mainToolHover);
	}
</style>
